import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 全局less
import './assets/style/global.less';

// 阿里图标
import './assets/fonts/iconfont.css';
import './assets/fonts/iconfont';
//OPPO字体
import  './assets/style/font.css';

//引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 引入vant
import './common/_vant'
import 'vant/lib/index.css';

// 适配
import 'amfe-flexible'

// 轮播
import VueSuperSlide from 'vue-superslide'
Vue.use(VueSuperSlide)

//指令 想要收集用户感兴趣内容，做数据埋点
//记录用户进入页面时间，表单录入时间，离开页面时间，停留详情图区域时间


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
